import * as style from './style.module.css';

const Overlay = ({ isOpen = false, zIndex = 1, onClose = () => {} }) => {
    return (
        <div
            style={{ zIndex }}
            className={`${style.overlay} ${isOpen ? style.isOpened : ''}`}
            onClick={onClose}
            onKeyDown={(e) => e.key === 'Enter' && onClose()}
            role="button"
            tabIndex={0}
        />
    );
};

export default Overlay;
